import React, { useState } from 'react';

import { useHistory } from 'react-router-dom';

import Accordion from '../../../../../components/Accordion';
import SearchContainer from '../../../../../components/SearchContainer';
import DataTableMui from '../../../../../components/DataTableMui';

import StepProgress from '../../../../../components/StepProgress';

import { buscaBeneficiarioAlteracaoCadastral } from '../../../../../services';
import { addMaskCpf } from '../../../../../utils';
import steps from '../../../../../utils/steps.json';

import { useGlobal } from '../../../../../contexts/Global/context';

import { ContainerButton, PageContainer } from '../../../../../styles/styles';
import { useBeneficiarioEventual } from '../../../../../contexts/BeneficiarioEventual/context';
import Button from '../../../../../components/Button';
import * as S from './styles';

function SelecionarBeneficiarioEventual() {
    const history = useHistory();
    const { setDataConsultaAtendimento, clearBeneficiarioEventual } = useBeneficiarioEventual();

    const { dataActiveContract } = useGlobal();

    const emptyMessage = 'Não encontramos esse beneficiário eventual. Você pode fazer uma nova pesquisa.';

    const [loading, setLoading] = useState(false);
    const [alreadySearched, setAlreadySearched] = useState(false);
    const [dataTable, setDataTable] = useState([]);
    const [beneficiarios, setBeneficiarios] = useState([]);

    async function handleSearch(value) {
        setAlreadySearched(false);

        let response = [];
        let treatedResponse = [];

        if (value) {
            setLoading(true);

            response =
                (await buscaBeneficiarioAlteracaoCadastral(value.trim().toUpperCase(), dataActiveContract.numero)) ||
                [];

            if (response !== undefined) {
                response = response?.length <= 0 ? undefined : response;
            }

            treatedResponse = response
                ? response.map((element, index) => ({
                    index,
                    nomeCompleto: element.nomeCompleto,
                    carteirinha: element.numCarteira,
                    cpf: addMaskCpf(element.cpf),
                }))
                : [];
        }

        setBeneficiarios(response);
        setDataTable(treatedResponse);
        setLoading(false);
        setAlreadySearched(true);
    }

    const columnsHead = [
        {
            key: 'numCarteirinha',
            selector: (row) => row.carteirinha || '-',
            name: 'Nº da carteirinha',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ padding: '0 16px 0 24px', width: '200px' }),
        },
        {
            key: 'nomeCompleto',
            selector: (row) => row.nomeCompleto || '-',
            name: 'Nome completo',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: 'calc(100% - 580px)', height: '60px' }),
        },
        {
            key: 'cpf',
            selector: (row) => row.cpf || '-',
            name: 'CPF',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: '160px' }),
        },
    ];

    function handleClickRow(row) {
        clearBeneficiarioEventual();


        const rawData = beneficiarios[row.index];

        setDataConsultaAtendimento({ beneficiarioEventual: rawData });


        history.push('/dados_beneficiario/consulta_beneficiario_eventual/agendamento_consulta_dados');
    }

    const rowMutation = {
        click: (row) => {
            handleClickRow(row);
        },
        hasClick: () => true,
    };

    return (
        <>
            <PageContainer>
                <StepProgress steps={steps.agendamentoConsulta} activeStep={1} />
                <Accordion title="Pesquisar beneficiário" hasCollapse={false}>
                    <SearchContainer
                        field={{
                            id: 'searchField',
                            label: 'Digite o nº da carteirinha, nome ou CPF',
                            required: true,
                        }}
                        disabled={loading}
                        onSearch={handleSearch}
                    />
                </Accordion>
                <S.cardGrid>
                    <DataTableMui
                        clickableRow
                        rowMutation={rowMutation}
                        data={dataTable}
                        pointerOnHover
                        loading={loading}
                        emptyMessage={emptyMessage}
                        columns={columnsHead}
                        alreadySearched={alreadySearched}
                        firstOrderBy="numCarteirinha"
                    />
                </S.cardGrid>
                <ContainerButton>
                    <Button
                        id="continueStep"
                        type="primary"
                        onClick={() => history.push('/registro_acidentados/consulta_beneficiario_eventual')}
                    >
                        Voltar
                    </Button>
                </ContainerButton>
            </PageContainer>
        </>
    );
}

export default SelecionarBeneficiarioEventual;
